import {AppliedDiscount} from '@wix/auto_sdk_ecom_current-cart';
import {CouponModel} from '../models/Cart/Coupon.model';

export const toAppliedCouponCartV1 = (appliedDiscounts: AppliedDiscount[]) => {
  const appliedCoupon = appliedDiscounts?.find((discount) => discount.coupon);
  return appliedCoupon ? CouponModel.fromCartV1(appliedCoupon.coupon) : undefined;
};
